import {Filter, TextInput} from 'react-admin'
export const ClubPointsFilter = (props) => (
	<Filter {...props} variant="outlined" margin="normal">
		<TextInput label="Search Club" source="$search" alwaysOn resettable variant="outlined" margin="normal" />
	</Filter>
)
export default ClubPointsFilter